import { useEffect, useState } from "react";
import api from "@/api/v1-jwt/config/api";
import { useQueryClient } from "@tanstack/react-query";
import { useAuth } from "@/providers/auth";
import { useProfile } from "@/hooks/profile/use-profile";

export const useStep = (step) => {
  const queryClient = useQueryClient();
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [postError, setPostError] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [isPostLoading, setIsPostLoading] = useState(false);
  const { cognitoId } = useAuth();
  const { data: profile } = useProfile();
  const baseURL = `/platform/application/submitted/${cognitoId}/step/${step}/${profile?.application_id}`;

  const handlePost = async (payload, callback) => {
    try {
      setIsPostLoading(true);
      await api.post(baseURL, payload);
      queryClient.invalidateQueries(["application", profile?.application_id]);
      queryClient.invalidateQueries(["profile"]);
      if (callback) {
        callback();
      }
    } catch (err) {
      setPostError(err);
    } finally {
      setIsPostLoading(false);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await api.get(baseURL);
        setData(response?.data);
      } catch (err) {
        setError(err);
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, [step, baseURL]);

  return {
    data,
    error,
    isLoading,
    handlePost,
    isPostLoading,
    postError,
  };
};
